export const IS_MOBILE = Boolean((a => (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))))(navigator.userAgent || navigator.vendor || (window as any).opera));
export const PHONE_REG_EXP = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const PASSWORD_REG_EXP = /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/;
export const USERNAME_REG_EXP = /^[a-zA-Z0-9]{4,20}$/;
export const AUTO_REFRESH_TIME = 5; // 5 seconds for auto refresh
export const REFRESH_DEBOUNCE_TIME = 1000; // 1 second
export const REFRESH_TIMEOUT_STRIPE_SUCCESS = 2000;

export enum WHITE_LABEL_BRANDS {
    RACING_EDGE = 'RACING_EDGE',
    P1_GROUPE = 'P1_GROUPE',
    P1_AUTO_AUCTIONS = 'P1_AUTO_AUCTIONS',
    RACE_CAR_LOCATORS = 'RACE_CAR_LOCATORS',
    SPEED_FANATICS = 'SPEED_FANATICS ',
    SPEED_FANATICS_AUCTIONS = 'SPEED_FANATICS_AUCTIONS',
    TEAM_STRADALE = 'TEAM_STRADALE',
}

export enum TEMPLATE_TYPES {
    RACING_EDGE = 'RACING_EDGE',
    NX_GEM = 'NX_GEM'
}

export const BRAND = process.env.REACT_APP_BRAND || WHITE_LABEL_BRANDS.RACING_EDGE;
export const TEMPLATE_TYPE = process.env.REACT_APP_TEMPLATE_TYPE || TEMPLATE_TYPES.RACING_EDGE;

// INDEX_PREFIX EXAMPLES: development_racingedge, development_nxgem, production_racingedge, production_nxgem
export const INDEX_PREFIX = `${process.env.REACT_APP_ENVIRONMENT || 'development'}_${TEMPLATE_TYPE.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()}`;
export const PADDOCK_LINK = TEMPLATE_TYPE === TEMPLATE_TYPES.NX_GEM ? 'shop' : 'paddock';
export const AUCTION_LINK = 'auction';
export const MAILCHIMP_URL = process.env.REACT_APP_MAILCHIMP_URL ? process.env.REACT_APP_MAILCHIMP_URL : '';

export const JWT_TOKEN = `jwtToken_${BRAND}`;
export const USER_TOKEN = `userToken_${BRAND}`;
export const FORCED_REFRESH_COOKIE = `forceRefreshed_${BRAND}`;
export const COOKIE_CONSENT = 'UserCookieConsent';
export const DEFAULT_CONTACT_PHONE_NUMBER = '+1 (855) 722-4643';

export const NO_LOGIN_WHITELABEL = BRAND === WHITE_LABEL_BRANDS.P1_GROUPE ||
                                   BRAND === WHITE_LABEL_BRANDS.RACE_CAR_LOCATORS ||
                                   BRAND === WHITE_LABEL_BRANDS.P1_AUTO_AUCTIONS ||
                                   BRAND === WHITE_LABEL_BRANDS.SPEED_FANATICS ||
                                   BRAND === WHITE_LABEL_BRANDS.TEAM_STRADALE ||
                                   BRAND === WHITE_LABEL_BRANDS.SPEED_FANATICS_AUCTIONS;

// ===================================================================
// ==================== FILTERING SECTION - START ====================
// For querying data locked to the configured Template Type
export const TEMPLATE_TYPE_CLAUSE = TEMPLATE_TYPE === TEMPLATE_TYPES.RACING_EDGE
    ? { _or: [{ templateType: TEMPLATE_TYPE }, { templateType_null: true }] }
    : { _or: [{ templateType: TEMPLATE_TYPE }] };

// For querying inventory (paddock) with the addition of brand/user filtering
const _inventoryOrFilter: any = [];
// Brands, i.e. (RACING_EDGE,NX_GEM)
const brands = process.env.REACT_APP_INVENTORY_BRAND_FILTER
    && process.env.REACT_APP_INVENTORY_BRAND_FILTER.split(',')
        .map(val => val.replace(/\W/g, '')).filter(val => !!val);
let brands_algolia_filter = '';
if (brands && brands.length) {
    // If there are brands to filter for
    const brandFilter = {
        brand_in: brands,
    };
    _inventoryOrFilter.push(brandFilter);
    brands_algolia_filter = `brand:${brands.join(' OR brand:')}`;
}
// Users, i.e. (123,246,369)
const users = process.env.REACT_APP_INVENTORY_USER_FILTER
    && process.env.REACT_APP_INVENTORY_USER_FILTER.split(',')
        .map(val => val.replace(/\W/g, '')).filter(val => !!val);
let users_algolia_filter = '';
if (users && users.length) {
    // If there are users to filter for
    const userFilter = {
        user_in: users,
    };
    _inventoryOrFilter.push(userFilter);
    users_algolia_filter = `listing_group.user:${users.join(' OR listing_group.user:')}`;
}
// Combine the Brand/User filters together for export
/**
 * @name INVENTORY_FILTER
 * @description For use in the "where" of a GraphQL Query, deconstruct this into the where.
 * @yields `{}`
 * @yields `{ _or: [{ brand_in:['RACING_EDGE','NX_GEM'] }] }`
 * @yields `{ _or: [{ user_in:['123','456'] }] }`
 * @yields `{ _or: [{ brand_in:['RACING_EDGE','NX_GEM'] }, { user_in:['123','456'] }] }`
 */
export const INVENTORY_FILTER = _inventoryOrFilter.length
    ? { _or: _inventoryOrFilter }
    : {};

// Build the algolia filter which looks for entries matching the Brand/User
let algolia_brand_user_filter = '';
if (brands_algolia_filter && users_algolia_filter) {
    algolia_brand_user_filter = `((${brands_algolia_filter}) OR (${users_algolia_filter}))`;
} else if (brands_algolia_filter) {
    algolia_brand_user_filter = `(${brands_algolia_filter})`;
} else if (users_algolia_filter) {
    algolia_brand_user_filter = `(${users_algolia_filter})`;
}
/**
 * @name INVENTORY_ALGOLIA_FILTER
 * @description For use in the "filters" of an Algolia search, typically appended e.g. `AND ${INVENTORY_ALGOLIA_FILTER}`.
 * @yields ``
 * @yields `(brand:RACING_EDGE)`
 * @yields `(listing_group.user:123)`
 * @yields `((brand:RACING_EDGE) OR (listing_group.user:123))`
 */
export const INVENTORY_ALGOLIA_FILTER = algolia_brand_user_filter;

// For querying media (paddock) with the addition of brand/user filtering
const _mediaOrFilter: any = [];
// Brands, i.e. (RACING_EDGE,NX_GEM)
const mediaBrands = process.env.REACT_APP_MEDIA_BRAND_FILTER
    && process.env.REACT_APP_MEDIA_BRAND_FILTER.split(',')
        .map(val => val.replace(/\W/g, '')).filter(val => !!val);
if (mediaBrands && mediaBrands.length) {
    // If there are mediaBrands to filter for
    const brandFilter = {
        brand_in: mediaBrands,
    };
    _mediaOrFilter.push(brandFilter);
}
// Users, i.e. (123,246,369)
const mediaUsers = process.env.REACT_APP_MEDIA_USER_FILTER
    && process.env.REACT_APP_MEDIA_USER_FILTER.split(',')
        .map(val => val.replace(/\W/g, '')).filter(val => !!val);
if (mediaUsers && mediaUsers.length) {
    // If there are mediaUsers to filter for
    const userFilter = {
        author_in: mediaUsers,
    };
    _mediaOrFilter.push(userFilter);
}
// Combine the Brand/User filters together for export
/**
 * @name MEDIA_FILTER
 * @description For use in the "where" of a GraphQL Query, deconstruct this into the where.
 */
export const MEDIA_FILTER = _mediaOrFilter.length
    ? { _and: [TEMPLATE_TYPE_CLAUSE, { _or: _mediaOrFilter }] }
    : TEMPLATE_TYPE_CLAUSE;
// ==================== FILTERING SECTION -  END  ====================
// ===================================================================

// In bytes
export const MAX_FILE_SIZE_UPLOAD = 5242880;

export const mappedPricingPackageOptions = [
    {
        key: 'imageLimit',
        label: 'image',
    },
    {
        key: 'videoLimit',
        label: 'video',
    }
];

export enum VARIATIONS {
    ORIGINAL = 'ORIGINAL',
    FILLED_PRIMARY = 'FILLED_PRIMARY',
    FILLED_SECONDARY = 'FILLED_SECONDARY',
    SIMPLE = 'SIMPLE',
    SIMPLE_TALL = 'SIMPLE_TALL',
}
// TODO: Renable other currencies when Square is configured to accept them
export enum CURRENCIES {
    USD = 'USD',
    // CAD = 'CAD',
    // AUD = 'AUD',
    // EUR = 'EUR',
    // GBP = 'GBP'
}

export enum SELLER_TYPES {
    PERSONAL = 'PERSONAL',
    AGENCY = 'DEALER'
}

export enum PAYMENT_STATUS {
    FREE = 'FREE',
    PAID = 'PAID',
    UNPAID = 'UNPAID',
    PENDING = 'PENDING',
    FAILED_PAYMENT = 'FAILED_PAYMENT',
    CANCELED = 'CANCELED',
    REQUIRES_ACTION = 'REQUIRES_ACTION',
}

export enum DIRECTORY_STATUS {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    DECLINED = 'DECLINED',
}

// Categories and their associated slugs
export enum CATEGORY {
    FOOTER_SECTION_1 = 'footer-section-1',
    FOOTER_SECTION_2 = 'footer-section-2',
    FOOTER_SECTION_3 = 'footer-section-3',
    FOOTER_SECTION_4 = 'footer-section-4',
    FOOTER_SECTION_5 = 'footer-section-5',
}

export enum TAG {
    TRENDING = 'trending',
    FEATURE = 'feature'
}

export enum PUBLICATION_STATE {
    LIVE = 'LIVE',
    PREVIEW = 'PREVIEW'
}

export enum PRICING_PACKAGE_TYPE {
    PADDOCK = 'PADDOCK',
    AUCTION = 'AUCTION',
    DIRECTORY = 'DIRECTORY',
    SIM_RACING = 'SIMRACING'
}

export enum FAQ_PAGE {
    HOME = 'home',
    MEDIA = 'media',
    PADDOCK = 'paddock',
    SIM_RACING = 'simracing',
    DIRECTORY = 'directory',
    SELL_MY_CAR = 'sellMyCar',
    AUCTION = 'auction',
}

export enum MAPPED_CURRENCY {
    USD = 'en-US',
    CAD = 'en-CA',
    EUR = 'en-IE',
    GBP = 'en-GB',
    AUD = 'en-AU',
    HKD = 'en-HK',
    SGD = 'en-SG',
    ISK = 'en-IS',
    PHP = 'en-PH',
    DKK = 'en-DK',
    HUF = 'en-HU',
    CZK = 'en-CZ',
    RON = 'en-RO',
    IDR = 'en-ID',
    INR = 'en-IN',
    BRL = 'en-BR',
    RUB = 'en-RU',
    HRK = 'en-HR',
    JPY = 'en-JP',
    THB = 'en-TH',
    CHF = 'en-CH',
    PLN = 'en-PL',
    BGN = 'en-BG',
    TRY = 'en-TR',
    CNY = 'en-CN',
    NOK = 'en-NO',
    NZD = 'en-NZ',
    ZAR = 'en-ZA',
    MXN = 'en-MX',
    ILS = 'en-IL',
    KRW = 'en-KR',
    MYR = 'en-MY',
    SEK = 'en-SE',
    KWD = 'en-KW'
}

export enum ACCEPTED_CRYPTOS {
    CRO = 'CRO',
    BTC = 'BTC',
    ETH = 'ETH',
    XRP = 'XRP',
    LTC = 'LTC'
}

export enum PAYMENT_TYPE {
    HOLD_PAYMENT = 'HOLD',
    ONE_TIME_PAYMENT = 'ONE_TIME',
    MONTHLY_PAYMENT = 'MONTHLY',
    YEARLY_PAYMENT = 'YEARLY',
}

export enum FIELD_TYPES {
    TEXT = 'TEXT',
    SELECT = 'SELECT',
    NUMBER = 'NUMBER',
    FLOAT = 'FLOAT',
    MAKE = 'MAKE',
    PRICE = 'PRICE',
    BOOLEAN = 'BOOLEAN',
    RICH_TEXT = 'RICH_TEXT'
}

export enum FORM_ACTION {
    CREATE = 'create',
    EDIT = 'edit'
}

export enum SOCKET_EVENT {
    AUCTION = 'auction',
    COMMENTS = 'comments',
    CONNECT = 'connect',
    DISCONNECT = 'disconnect'
}

export enum SOCKET_EMITTERS {
    JOIN_AUCTION_LOT = 'joinAuctionLot',
    LEAVE_AUCTION_LOT = 'leaveAuctionLot',
    GET_AUCTION = 'getAuction',
    BID = 'bid',
    COMMENT = 'comment',
    GET_COMMENTS = 'getComments'
}

export enum SOCKET_DISCONNECT_REASON {
    IO_SERVER = 'io server disconnect', // The server has forcefully disconnected the socket with socket.disconnect()
    IO_CLIENT = 'io client disconnect', // The socket was manually disconnected using socket.disconnect()
    PING_TIMEOUT = 'ping timeout', // The server did not send a PING within the pingInterval + pingTimeout range
    TRANSPORT_CLOSE = 'transport close', // The connection was closed (example: the user has lost connection, or the network was changed from WiFi to 4G)
    TRANSPORT_ERROR = 'transport error' // The connection has encountered an error (example: the server was killed during a HTTP long-polling cycle)
}

export enum CRYPTO_CURRENCIES {
    BTC = 'BTC',
    ETH = 'ETH',
    LTC = 'LTC',
    DODGE = 'DODGE',
    ADA = 'ADA',
}

export enum FIAT_CURRENCIES {
    USD = 'USD',
    CAD = 'CAD',
    GBP = 'GBP',
    EUR = 'EUR',
    AUD = 'AUD',
    HKD = 'HKD',
    SGD = 'SGD'
}

export enum EXCHANGE_RATE_CURRENCIES {
    BTC = 'BTC',
    ETH = 'ETH',
    LTC = 'LTC',
    DODGE = 'DODGE',
    ADA = 'ADA',
    USD = 'USD',
    CAD = 'CAD',
    GBP = 'GBP',
    EUR = 'EUR',
    AUD = 'AUD',
    HKD = 'HKD',
    SGD = 'SGD'
}

export enum CRYPTO_CURRENCIES_SYMBOLS {
    ADA = '₳',
    BCH = 'Ƀ',
    BSV = 'Ɓ',
    BTC = '₿',
    DAI = '◈',
    DOGE = 'Ð',
    EOS = 'ε',
    ETC = 'ξ',
    ETH = 'Ξ',
    LTC = 'Ł',
    MKR = 'Μ',
    REP = 'Ɍ',
    STEEM = 'ȿ',
    USDT = '₮',
    XMR = 'ɱ',
    XRP = '✕',
    XTZ = 'ꜩ',
    ZEC = 'ⓩ'
}

export enum COMMENT_REPORT_REASON {
    BAD_LANGAUGE = 'BAD_LANGAUGE',
    DISCRIMINATION = 'DISCRIMINATION',
    OTHER = 'OTHER'
}

export enum CMS_FIELD_TYPE {
    COMMENT = 'comments',
    AUCTION = 'auctions'
}

export enum CMS_CONTENT_TYPE_REF {
    AUCTION = 'auction',
}
export const NAVIGATED_TO_LISTING = (): void => {
    window.scrollTo(0, 0);
};

export enum CREDIT_CARD_BRAND {
    OTHER_BRAND = 'OTHER_BRAND',
    VISA = 'VISA',
    MASTERCARD = 'MASTERCARD',
    AMERICAN_EXPRESS = 'AMERICAN_EXPRESS',
    DISCOVER = 'DISCOVER',
    DISCOVER_DINERS = 'DISCOVER_DINERS',
    JCB = 'JCB',
    CHINA_UNIONPAY = 'CHINA_UNIONPAY',
    SQUARE_GIFT_CARD = 'SQUARE_GIFT_CARD',
    SQUARE_CAPITAL_CARD = 'SQUARE_CAPITAL_CARD',
    INTERAC = 'INTERAC',
    EFTPOS = 'EFTPOS',
    FELICA = 'FELICA',
    EBT = 'EBT'
}

export enum APOLLO_GRAPHQL_ERROR {
    FORBIDDEN = 'Forbidden',
    INVALID_TOKEN = 'Invalid token.',
    USER_NOT_FOUND = 'User Not Found',
}

export const WIZARD_SUBMITTING_STATE_DELAY = 10000;

export enum AUCTION_DEFAULT_CONSTANTS {
    SNIPER_PROTECTION_TIME = 120,
    DISPLAY_LIMIT = 15,
    DATE_RANGE_LIMIT = 7,
    BID_MIN_INCREMENT = 1,
    // 1 = true, 0 = false
    RESERVE_METER_ENABLED = 1,
    // Green color as default
    RESERVE_METER_FILL_COLOR = '#008000'
}

export enum PAYMENT_ITEM_TYPE {
    AUCTION = 'AUCTION',
    BID = 'BID',
    LISTING = 'LISTING',
    DIRECTORY = 'DIRECTORY'
}

export enum PAYMENT_PROVIDER {
    SQUARE = 'SQUARE',
    STRIPE = 'STRIPE',
    CRYPTO_DOT_COM = 'CRYPTO_DOT_COM'
}

export const isP1Groupe = BRAND === WHITE_LABEL_BRANDS.P1_GROUPE;
export const isRacingEdge = BRAND === WHITE_LABEL_BRANDS.RACING_EDGE;
